<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_2"></a><strong>BOOKS BY ROBERT SILVERBERG<br/>FROM TOM DOHERTY ASSOCIATES</strong></p>
<p class="para"> </p>
<p class="center-para"><em>Dying Inside<br/>A Time of Changes</em></p>
<p class="linespace"> </p>
<p class="center-para"><strong>EDITED BY ROBERT SILVERBERG</strong></p>
<p class="para"> </p>
<p class="center-para"><em>Legends-Vol. 1 Stories by the Masters of Modern Fantasy<br/>Legends-Vol. 2 Stories by the Masters of Modern Fantasy<br/>Legends-Vol. 3 Stories by the Masters of Modern Fantasy<br/>Science Fiction Hall of Fame, Volume One</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?9570d03e